
export const calcRandomNumberWithMax = (maximum, excludeMax, nbrDigits) => {
 
      let multiplier = 0;
      if (!excludeMax || excludeMax === false){
            // Returns a random integer from 0 to maximum (maximum is a valid return value)
            multiplier = +maximum + 1;
      }else{
            // Returns a random integer from 0 to maximum minus 1 (maximum is not a valid return value)
            multiplier = maximum;
      }
      if (!nbrDigits){
            nbrDigits = 1;
      }
      let randomArr = [];
      for (let i=0; i<nbrDigits; i++){
            let randomNbr = Math.floor(Math.random() * multiplier);
            randomArr.push(randomNbr);
      }
      let outRandomNbr = randomArr.join(", ");
      outRandomNbr = outRandomNbr.replaceAll(", ", "");
      outRandomNbr = +outRandomNbr;
                
      return outRandomNbr;
   
}
export default calcRandomNumberWithMax;





